module.exports = __webpack_public_path__ + "img/1526927502.62bed7f2.jpg";